/**
 * ページ内リンクのスムーススクロール。
 *
 * 旧 Diver は a[href*="#"] を横取りし、対象 id が同一ページにあれば
 * preventDefault してスクロールしていた。クラシックエディタ由来の
 * /1000/年ダミーURL（例: /blog/1000/03/15/slug/#37200）もこれで動いていた。
 *
 * 数字始まりの id（TOC+ の #37200 など）は jQuery('#37200') では取れないため
 * document.getElementById を使う。
 */
const initSmoothScroll = () => {
  $(document).on('click', 'a[href*="#"]', function (event) {
    if (this.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const href = this.getAttribute('href');
    if (!href || href === '#') {
      return;
    }

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (err) {
      return;
    }

    if (url.origin !== window.location.origin || !url.hash || url.hash === '#') {
      return;
    }

    const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
    const currentPath = normalizePath(window.location.pathname);
    const targetPath = normalizePath(url.pathname);
    const currentSlug = currentPath.split('/').filter(Boolean).pop() || '';
    const targetSlug = targetPath.split('/').filter(Boolean).pop() || '';
    const isDummyYear = /\/1000\//.test(url.pathname);
    const isSamePage = currentPath === targetPath || (isDummyYear && currentSlug === targetSlug);

    if (!isSamePage) {
      return;
    }

    const id = decodeURIComponent(url.hash.slice(1));
    const targetEl = document.getElementById(id);
    if (!targetEl) {
      return;
    }

    event.preventDefault();

    const header = document.querySelector('.l-header');
    const adjust = header ? header.getBoundingClientRect().height : 0;
    const top = targetEl.getBoundingClientRect().top + window.pageYOffset - adjust;
    $('body,html').animate({ scrollTop: top }, 400, 'swing');
  });
};

export default initSmoothScroll;
